import styled, { keyframes } from "styled-components";
import { Col, Card, Row } from "react-bootstrap";

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const StyledTechCard = styled(Card)`
  background: rgba(11, 1, 1, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(19px);
  -webkit-backdrop-filter: blur(19px);
  border-color: transparent;
  border-radius: 16px;
  height: auto;
  justify-content: center;
  padding-bottom: 40px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff003c, #fea794, #ff003c);
    background-size: 200% 100%;
  }
`;

const SectionTitle = styled.h3`
  background: linear-gradient(135deg, #ff003c, #fea794);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: "";
    width: 4px;
    height: 28px;
    background: linear-gradient(180deg, #ff003c, #fea794);
    border-radius: 2px;
  }
`;

const CategoryTitle = styled.h6`
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "";
    width: 16px;
    height: 2px;
    background: linear-gradient(90deg, #ff003c, #fea794);
  }
`;

const SkillTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  padding: 8px 14px;
  border-radius: 8px;
  margin: 4px;
  transition: all 0.3s ease;
  cursor: default;

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(255, 0, 60, 0.15),
      rgba(254, 167, 148, 0.1)
    );
    border-color: rgba(255, 0, 60, 0.4);
    color: #fea794;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 0, 60, 0.2);
  }
`;

const SkillCategory = styled.div`
  margin-bottom: 24px;
`;

const SkillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const StyledLine = styled.hr`
  background: linear-gradient(
    to right,
    transparent,
    rgba(255, 0, 60, 0.3),
    transparent
  );
  height: 1px;
  border: 0;
  margin: 16px 0 24px 0;
`;

function TechStack() {
  const techCategories = [
    {
      name: "Frontend",
      skills: ["Vue", "React", "Nuxt.js", "Next.js"],
    },
    {
      name: "Backend",
      skills: ["Node.js", "NestJS", "Express", "Strapi"],
    },
    {
      name: "Database",
      skills: ["SQL", "NoSQL", "Firebase", "Redis"],
    },
    {
      name: "DevOps",
      skills: ["Docker", "NGINX", "Git", "CI/CD"],
    },
    {
      name: "APIs & Integration",
      skills: ["REST API", "GraphQL", "gRPC"],
    },
    {
      name: "Platforms",
      skills: ["LINE API", "WordPress", "Cloud Services"],
    },
  ];

  return (
    <>
      <Col md={12} className="mt-3 mx-auto">
        <StyledTechCard className="shadow-sm">
          <Card.Title className="pt-4 px-4">
            <SectionTitle>Tech Stack</SectionTitle>
            <StyledLine />
          </Card.Title>
          <Card.Body className="pb-0 pt-1 px-4">
            <Row>
              {techCategories.map((category, index) => (
                <Col lg={4} md={6} key={index} className="mb-4">
                  <SkillCategory>
                    <CategoryTitle>{category.name}</CategoryTitle>
                    <SkillsWrapper>
                      {category.skills.map((skill, idx) => (
                        <SkillTag key={idx}>{skill}</SkillTag>
                      ))}
                    </SkillsWrapper>
                  </SkillCategory>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </StyledTechCard>
      </Col>
    </>
  );
}

export default TechStack;
